import {
  FAKE_COMMENT_ADDED_VERSION_LABEL,
  FAKE_COMMENT_EDITED_VERSION_LABEL,
  FAKE_COMMENT_FILE_ACTION,
} from './cfakecommentConstants';
import type { FakeCommentFileAttachment } from './cfakecommentTypes';

export function getFakeCommentFileVersionLabel(
  message: FakeCommentFileAttachment,
): string {
  if (message.versionLabel) {
    return message.versionLabel.toUpperCase();
  }

  return message.action === FAKE_COMMENT_FILE_ACTION.Added
    ? FAKE_COMMENT_ADDED_VERSION_LABEL
    : FAKE_COMMENT_EDITED_VERSION_LABEL;
}

export function getFakeCommentDisplayFileName(fileName: string): string {
  const extensionIndex = fileName.lastIndexOf('.');

  if (extensionIndex <= 0) {
    return fileName;
  }

  return fileName.slice(0, extensionIndex);
}
